import React, { FC } from 'react'
import { ClickAwayListener, Tooltip, TooltipProps } from '@mui/material'
import { useControlledTooltip } from '../../../hooks/useContolledTooltip'
import { PopperWrap } from './StyledComponents'

type AdditionalProps = {
  arrowHorizontalPosition?: 'left' | 'center' | 'right'
}

const ControlledTooltip: FC<TooltipProps & AdditionalProps> = ({
  title,
  arrowHorizontalPosition,
  arrow = true,
  children,
  ...rest
}) => {
  const { tooltipListeners, tooltipOpen, handleTooltipClose } = useControlledTooltip()
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        open={tooltipOpen}
        disableFocusListener
        disableTouchListener
        disableHoverListener
        {...tooltipListeners}
        arrow
        classes={{ arrow: arrowHorizontalPosition ?? '' }}
        title={<PopperWrap {...tooltipListeners}>{title}</PopperWrap>}
        {...rest}
      >
        {children}
      </Tooltip>
    </ClickAwayListener>
  )
}
export default ControlledTooltip
